export default Object.freeze({
  PARTNER: '파트너사',
  SHOP: '쇼핑몰 자체 상품',
  ALL: '전체',
  PLEASE_INPUT_PARTNER_NAME: '파트너사명을 입력해주세요.',
  ALERT_NOT_INPUT_PARTNER_NAME: '파트너사명이 입력되지 않았습니다.',
});
